export default __webpack_public_path__ + "static/media/background.a9c34c2f.mp4";